<template>
  <div class="flex h-screen sci-fi-grid">
    <slot />
  </div>
</template>
